export const NO_DATA = 'No Data';
export const NOT_APPLICABLE = 'N/A';
export const THREE_EM_DASH = '---';
export const EMPTY_TEXT_FILLER = '--';
